import React, { Component } from 'react';
import PropTypes from 'prop-types';
import _sortBy from 'lodash/sortBy';
import _get from 'lodash/get';
import _compact from 'lodash/compact';
import classNames from 'classnames/bind';
import { injectIntl } from 'react-intl';

import Heading from '../Heading';
import VariationInfo from '../VariationInfo';
import AddedIngredients from '../AddedIngredients';
import RemovedIngredients from '../RemovedIngredients';
import { isCombobox } from '../../utils/catalog';
import OrderItemAddedSauce from './OrderItemAddedSauce';

import styles from './OrderItemDescription.styl';

const cx = classNames.bind(styles);

class OrderItemDescriptionView extends Component {
  getSize = good => {
    const sizeValue = _get(good, 'size.value', '');
    const sizeUnit = _get(good, 'size.unit', '');

    if (sizeValue && sizeUnit) {
      return `${sizeValue}&nbsp;${sizeUnit}`;
    }

    return false;
  };

  renderDescription = () => {
    const { intl, ...good } = this.props;

    const crust = _get(good, 'item.stuffed_crust');

    const kindName =
      _get(good, 'item.category_id', null) === 1 ? _get(good, 'item.kind.name', '') : '';

    const size = this.getSize(good.item);
    const count = good.count > 1 ? `(${good.count})` : '';

    const description = _compact([size, count]).join(' ');

    return (
      <React.Fragment>
        <span
          dangerouslySetInnerHTML={{
            __html: `${kindName && `${kindName}, `}${description}`,
          }}
        />

        {crust && crust !== 'none' && (
          <React.Fragment>
            {' + '}
            {intl.formatMessage({ id: `pizza.stuffedCrust.${crust}` }).toLowerCase()}
          </React.Fragment>
        )}
      </React.Fragment>
    );
  };

  renderComboboxDescription = () => {
    const combo_box_items = _get(this.props, 'item.combo_box_items', []);

    return (
      <div className={cx('OrderItemDescription__combobox')}>
        {_sortBy(combo_box_items, 'category_id').map(item => (
          <div key={item.id} className={cx('OrderItemDescription__comboboxItem')}>
            <Heading level={5}>{item.custom_name || item.name}</Heading>
            <VariationInfo
              {...item}
              className={cx('OrderItemDescription__comboboxVariationInfo')}
            />
            {item.removed_ingredients.length > 0 && (
              <RemovedIngredients list={item.removed_ingredients} />
            )}
          </div>
        ))}
      </div>
    );
  };

  render() {
    const { className, item = {} } = this.props;

    let added_ingredients = [];
    let removed_ingredients = [];

    if (this.props.type === 'combo') {
      added_ingredients = this.props.added_ingredients || [];
      removed_ingredients = this.props.removed_ingredients || [];
    } else {
      added_ingredients = item.added_ingredients || [];
      removed_ingredients = item.removed_ingredients || [];
    }

    const added_sauces = item.added_sauces || [];
    const name = item.custom_name || item.name || '';

    return (
      <div className={cx('OrderItemDescription', className)}>
        {isCombobox(this.props) ? (
          <>
            <Heading level={5}>{name}:</Heading>
            <div
              className={cx('OrderItemDescription__text', 'OrderItemDescription__text_combobox')}
            >
              {this.renderComboboxDescription()}
            </div>
          </>
        ) : (
          <>
            <Heading level={5}>{name}</Heading>
            <div className={cx('OrderItemDescription__text')}>{this.renderDescription()}</div>
          </>
        )}
        {added_ingredients.length > 0 && <AddedIngredients list={added_ingredients} item={item} />}
        {removed_ingredients.length > 0 && <RemovedIngredients list={removed_ingredients} />}
        {added_sauces.length > 0 && (
          <div className={cx('OrderItemDescription__AddedSauces')}>
            {added_sauces.map(sauce => (
              <OrderItemAddedSauce key={sauce.hash} {...sauce} />
            ))}
          </div>
        )}
      </div>
    );
  }
}

OrderItemDescriptionView.defaultProps = {
  name: '',
  custom_name: '',
  added_ingredients: [],
  removed_ingredients: [],
  type: '',
  className: '',
};

OrderItemDescriptionView.propTypes = {
  item: PropTypes.object,
  type: PropTypes.string,
  name: PropTypes.string,
  className: PropTypes.string,
  custom_name: PropTypes.string,
  added_ingredients: PropTypes.array,
  removed_ingredients: PropTypes.array,
  intl: PropTypes.object,
};

export default injectIntl(OrderItemDescriptionView);
